import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/kidizen-seller-guide';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling on Kidizen: A Beginner's Guide</title>
        <meta
          name='description'
          content="Looking for a new way to make money? Then selling on Kidizen might be the answer! Here's everything you need to learn to start selling on Kidizen."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/kidizen-seller-guide' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/kidizen-seller-guide' />
        <meta property='og:title' content="Selling on Kidizen: A Beginner's Guide" />
        <meta
          property='og:description'
          content="Looking for a new way to make money? Then selling on Kidizen might be the answer! Here's everything you need to learn to start selling on Kidizen."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-12T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-12T00:00:00-00:00' />
        <meta property='article:tag' content='Kidizen' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
